// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `GridCol` component.
 */

const GridCol = ({
    baseClassName,
    className,
    children,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
}) => {
    const computedClassName = classNames(
        baseClassName,
        {
            [`${baseClassName}--xs-${xs}`]: xs,
            [`${baseClassName}--sm-${sm}`]: sm,
            [`${baseClassName}--md-${md}`]: md,
            [`${baseClassName}--lg-${lg}`]: lg,
            [`${baseClassName}--xl-${xl}`]: xl,
        },
        className
    );
    return (
        <div className={computedClassName} {...props}>
            {children}
        </div>
    );
};

GridCol.propTypes = {
    /**
     * Content of the `GridCol`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * Column size for `xs` breakpoint (from 1 to 12)
     */
    xs: PropTypes.number,
    /**
     * Column size for `sm` breakpoint (from 1 to 12)
     */
    sm: PropTypes.number,
    /**
     * Column size for `sm` breakpoint (from 1 to 12)
     */
    md: PropTypes.number,
    /**
     * Column size for `md` breakpoint (from 1 to 12)
     */
    lg: PropTypes.number,
    /**
     * Column size for `lg` breakpoint (from 1 to 12)
     */
    xl: PropTypes.number,
};
GridCol.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}grid__col`,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
};

export default GridCol;



// WEBPACK FOOTER //
// ./components/GridCol/GridCol.js